module.exports = "<main>\n  <router-outlet #routerOutlet=\"outlet\"></router-outlet>\n</main>\n"